import { render, staticRenderFns } from "./vue-wave-surfer.vue?vue&type=template&id=5cabf620&scoped=true"
import script from "./vue-wave-surfer.vue?vue&type=script&lang=js"
export * from "./vue-wave-surfer.vue?vue&type=script&lang=js"
import style0 from "./vue-wave-surfer.vue?vue&type=style&index=0&id=5cabf620&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cabf620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cabf620')) {
      api.createRecord('5cabf620', component.options)
    } else {
      api.reload('5cabf620', component.options)
    }
    module.hot.accept("./vue-wave-surfer.vue?vue&type=template&id=5cabf620&scoped=true", function () {
      api.rerender('5cabf620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vue-wave-surfer.vue"
export default component.exports